var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"24","fill":"none"}},[_c('rect',{attrs:{"width":"17","height":"17","x":".5","y":"3.5","stroke":"currentColor","rx":"3.5"}}),_c('path',{attrs:{"fill":"currentColor","d":"M13.3 12.8H9.66v3.58H7.98V12.8H4.34v-1.58h3.64v-3.6h1.68v3.6h3.64z"}})])
}
var staticRenderFns = []

export default { render: render }